import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Link,
  OutlinedInput,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import * as AuthActions from '../../../../store/actions/auth.action';
import { getLoading } from '../../../../store/selector/auth.selector';

const styles = {
  FormContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  OtpContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
    width: '100%',
    maxWidth: '25rem',
  },

  verifyButton: { p: 2, mt: 4, mb: 1 },

  cancelButton: { p: 2 },
};

const LoginIcon = styled(AdminPanelSettingsIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 90,
  mb: '2rem',
}));

const AuthForm = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(getLoading);

  const [formValues, setFormValues] = useState({
    email: '',
  });

  const onChangeHandler = (identifier: string, event: React.ChangeEvent<HTMLInputElement>) => {
    setFormValues((prev) => {
      return { ...prev, [identifier]: event.target.value };
    });
  };

  const onSubmitHandler = () => {
    const { email } = formValues;

    /* istanbul ignore else */
    if (email) dispatch(AuthActions.Login({ email: email }));
  };

  const navEmployeeRegistration = () => {
    navigate('/employee/registration');
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.OtpContainer}>
        <LoginIcon />

        <Typography sx={{ fontSize: '2.375rem' }}>Online HR Clearance</Typography>
        <Typography sx={{ fontSize: '1rem', mb: '2rem' }}>
          Please enter your email so we can send you an OTP.
        </Typography>

        <Box sx={styles.FormContainer}>
          <FormControl>
            <InputLabel htmlFor='email'>Email</InputLabel>
            <OutlinedInput
              autoComplete='off'
              id='email'
              value={formValues.email}
              onChange={onChangeHandler.bind(this, 'email')}
              label='email'
            />
          </FormControl>

          <Button
            type='button'
            variant='contained'
            color='primary'
            onClick={onSubmitHandler}
            disabled={isLoading}
            size='large'
            sx={{
              p: 2,
              mt: '2rem',
              mb: '2rem',
            }}
            disableElevation
          >
            Login
          </Button>

          <Typography>
            {'Need to enroll for online clearance? '}
            <Link
              onClick={navEmployeeRegistration}
              sx={{ textDecoration: 'none', color: theme.palette.primary.main, cursor: 'pointer' }}
            >
              Click here
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default AuthForm;
